import React, { FC } from 'react';
import translate from '@translate';
import { useNavigate } from 'react-router-dom';
import { AddIcon, ReloadIcon } from 'src/components/SkladonIcon/Icons';
import WebhooksSettingsTopBlock from '../SettingsContainer/WebhooksSettingsTopBlock';

type TopBlockProps = {
    reloadWebhooksList: () => void;
    permissionCreate: boolean;
};

const TopBlock: FC<TopBlockProps> = (props) => {
    const navigate = useNavigate();

    const handleNew = () => {
        navigate('/settings/webhooks/new');
    };

    return (
        <WebhooksSettingsTopBlock
            actions={[
                {
                    onClick: props.reloadWebhooksList,
                    icon: <ReloadIcon />,
                    tooltip: translate('webhooks.action.synchronizeTable'),
                    variant: 'outlined',
                },
                {
                    label: translate('webhooks.action.createNew'),
                    onClick: handleNew,
                    icon: <AddIcon />,
                    hidden: !props.permissionCreate,
                },
            ]}
        />
    );
};

export default TopBlock;
